<template>
  <div class='timeSleep'>
    <div class="explain">
        <img src="@/assets/img/equipment/topImg4.png" class="imgs">
        <!-- <div class="txt">管理其他家长<br><span>实现共同管理</span></div> -->
    </div>
    <div :class='["list",status?"":"listGray"]'>
       <div class="con flex-between">
            <span class="text">定时休眠</span>
            <van-switch v-model="status" size=".28rem" @change="changeStatus"/>
       </div>
       <div class="con flex-between">
            <span class="text">开始时间</span>
            <p class="gray flex-between" @click="show(1)">
               <span>{{note[0]}}&nbsp;&nbsp;{{startTime}}</span>
               <svg-icon icon-class="right"/></p>
       </div>
       <div class="con flex-between">
            <span class="text">结束时间</span>
            <p class="gray flex-between" @click="show(2)">
              <span>{{note[1]}}&nbsp;&nbsp;{{endTime}}</span>
              <svg-icon icon-class="right"/></p>
       </div>
       <p class="note font14 gray"><van-icon name="info" class='info' />注意：充电状态，定时休眠不生效</p>
      
    </div>
   
  <!--添加-->
    <van-action-sheet v-model="isSet" :lazy-render='false'>
      <p class="pickNote">可选择的时间范围为当日21:00-次日06:00</p>
      <van-picker ref = "picker" show-toolbar :title='titles'  :columns="columns" @change="onChange" @confirm='confirm' @cancel='isSet=false' />
    </van-action-sheet>
  
  </div>
</template>
<script>
import {getDormancyInfo,sleepUpdate,sleepUpdateStatus} from "@/api/api.equipment";
  export default {
    data() {
      return {
        isSet:false,
        startTime:'',
        endTime:'',
        status:true,
        titles:'',
        note:['晚上','次日'],
        }
    },
    created(){
      this.getInfo();
      this.getTime();
    },
    methods: {
       getTime(){
          let times={};
          let arr=[],arr1=['21','22','23','00','01','02','03','04','05'];
          for(var i=0;i<60;i++){
            let a=i;
            if(i<10){
             a='0'+i;
            }
            arr.push(a);
          }
          arr1.forEach(item=>{
             times[item]=arr;
          });
          times['06']=['00'];
          this.times=times;
          this.columns=[{ values: Object.keys(times) }, { values: times['21'] }];
       },
       onChange(picker, values) {
          picker.setColumnValues(1, this.times[values[0]]);
       },
       getInfo(){
          getDormancyInfo({studentId:this.loginUser.studentId}).then(data=>{
             this.startTime=data.result.startTime||'22:00';
             this.endTime=data.result.endTime||'06:00';
             this.status=data.result.status==1?true:false;
             let arr=data.result.startTime.split(':');
             let arr1=data.result.endTime.split(':');
             this.note[0]=parseInt(arr[0])>6?'晚上':'次日';
             this.note[1]=parseInt(arr1[0])>6?'晚上':'次日';
          })
       }, 
       changeStatus(){
         if(!this.status){
            this.$dialog.confirm({
                title:'关闭定时休眠',
                message: '关闭定时休眠将会导致设备耗电变大，确定要关闭吗？',
                confirmButtonColor:'#0A59F7',
                cancelButtonColor:'#0A59F7',
                confirmButtonText:'确定'
            }).then(() => {
                  sleepUpdateStatus({status:this.status?1:0,studentId:this.loginUser.studentId}).then(data=>{
                            if(data) return;
                            this.status=!this.status;
                        })
                  }).catch(() => {
                          this.status=!this.status
                  });
         }else{
                  sleepUpdateStatus({status:this.status?1:0,studentId:this.loginUser.studentId}).then(data=>{
                        if(data) return;
                        this.status=!this.status;
                      
                  })
         }
          
       },
       show(type){
         if(!this.status) return;
         this.type=type;
         this.isSet=true;
         let arr='';
         if(type==1){//开始时间
           arr=this.startTime.split(':');
           this.titles='开始时间';
         }else{//结束时间
           arr=this.endTime.split(':');
           this.titles='结束时间';
         }
         
         this.$refs.picker.setColumnValue(0,arr[0]);
         this.$refs.picker.setColumnValue(1,arr[1]);
       },
       confirm(value){
          this.isSet=false;
          this.submit(value.join(':'));
       },
       submit(value){
         let params={
                startTime:this.type==1?value:this.startTime,
                endTime:this.type==2?value:this.endTime,
                studentId:this.loginUser.studentId
             };
          sleepUpdate(params).then(data=>{
            if(data){
              let arr=value.split(':');
                if(this.type==1){//开始时间
                    this.startTime=value;
                    this.note[0]=parseInt(arr[0])>6?'晚上':'次日';
                }else{//结束时间
                    this.endTime=value;
                    this.note[1]=parseInt(arr[0])>6?'晚上':'次日';
                }
                this.$toast('操作成功');
            }
            
          })
       },
      
    },
  }
</script>
<style lang="scss" >
.timeSleep{
   padding:0.12rem;
   .explain{
     position: relative;
     .imgs{
        width: 100%;
      }
   }
   
  .list{
    color:#333;
    font-size: .15rem;
    .con{
        margin-top:.12rem;
        padding:0rem .12rem;
        line-height: .48rem;
        background: #fff;
        border-radius: 8px;
        .text{
          font-size: .17rem;
        }
    }
    .van-switch::before{
      content:'关';
      color:#999;
      font-size: .17rem;
      position: absolute;
      top:.03rem;
      right: .08rem;
      line-height: .25rem;
    }
    .van-switch--on::before{
      content: '开';
      color:#fff;
      left: .08rem;
      // display: inline-block;
    }
    .note{
      margin-top: .12rem;
      .info{
        color:#0075FF;
        font-size: .16rem;
        margin-right: .04rem;
        vertical-align: bottom;
      }
    }
  }
  .van-action-sheet__content{
     position: relative;
     .pickNote{
       position: absolute;
       font-size: .12rem;
       color:#000;
       opacity:.6;
       z-index: 2;
       width: 100%;
       top: .48rem;
       text-indent: 16px;
       background: #fff;
     }
  }
  
}

</style>